"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.runCallbacks = exports.onNotificationDismissed = exports.onNotificationPresented = exports.createRegisteredCallbacks = void 0;
const vue_1 = require("vue");
const injection_symbols_1 = require("./injection-symbols");
function createRegisteredCallbacks() {
    return {
        notificationPresented: [],
        notificationDismissed: []
    };
}
exports.createRegisteredCallbacks = createRegisteredCallbacks;
const unscopedRegisteredCallbacks = createRegisteredCallbacks();
function registerCallback(type, callback) {
    unscopedRegisteredCallbacks[type].push(callback);
    if ((0, vue_1.getCurrentInstance)()) {
        const localRegisteredCallbacks = (0, vue_1.inject)(injection_symbols_1.appNotificationsRegisteredCallbacksKey);
        if (localRegisteredCallbacks) {
            localRegisteredCallbacks[type].push(callback);
        }
    }
}
function unregisterCallback(type, callback) {
    let callbackIndex = unscopedRegisteredCallbacks[type].indexOf(callback);
    if (callbackIndex > -1) {
        unscopedRegisteredCallbacks[type].splice(callbackIndex, 1);
    }
    if ((0, vue_1.getCurrentInstance)()) {
        const localRegisteredCallbacks = (0, vue_1.inject)(injection_symbols_1.appNotificationsRegisteredCallbacksKey);
        if (localRegisteredCallbacks) {
            callbackIndex = localRegisteredCallbacks[type].indexOf(callback);
            if (callbackIndex > -1) {
                localRegisteredCallbacks[type].splice(callbackIndex, 1);
            }
        }
    }
}
function onNotificationPresented(callback) {
    if ((0, vue_1.getCurrentInstance)()) {
        (0, vue_1.onBeforeUnmount)(() => {
            unregisterCallback('notificationPresented', callback);
        });
    }
    registerCallback('notificationPresented', callback);
    return function remove() {
        unregisterCallback('notificationPresented', callback);
    };
}
exports.onNotificationPresented = onNotificationPresented;
function onNotificationDismissed(callback) {
    if ((0, vue_1.getCurrentInstance)()) {
        (0, vue_1.onBeforeUnmount)(() => {
            unregisterCallback('notificationDismissed', callback);
        });
    }
    registerCallback('notificationDismissed', callback);
    return function remove() {
        unregisterCallback('notificationDismissed', callback);
    };
}
exports.onNotificationDismissed = onNotificationDismissed;
function runCallbacks(type, arg, localRegisteredCallbacks) {
    return __awaiter(this, void 0, void 0, function* () {
        let returnValue = undefined;
        if (localRegisteredCallbacks) {
            for (const callback of localRegisteredCallbacks[type]) {
                const potentialReturnValue = yield callback(arg);
                if (potentialReturnValue !== undefined) {
                    /* istanbul ignore next */
                    returnValue = potentialReturnValue;
                }
            }
        }
        else {
            for (const callback of unscopedRegisteredCallbacks[type]) {
                const potentialReturnValue = yield callback(arg);
                if (potentialReturnValue !== undefined) {
                    /* istanbul ignore next */
                    returnValue = potentialReturnValue;
                }
            }
        }
        return returnValue;
    });
}
exports.runCallbacks = runCallbacks;
//# sourceMappingURL=lifecycle-hooks.js.map